import type { NextPage } from 'next';
import Content from '../components/wizard-flows/TermsAndConditions';
import { Box } from '@chakra-ui/react';

const TermsAndConditions: NextPage = () => {
  return (
    <Box width="100%" maxWidth="7xl" m="auto" p={5}>
      <Content />
    </Box>
  );
};

export default TermsAndConditions;
